import { Component, useEffect } from "react";
import "@/App.css";
import { MotionConfig } from "framer-motion";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Sectors from "@/components/Sectors";
import Resources from "@/components/Resources";
import Download from "@/components/Download";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { initLenis, destroyLenis } from "@/lib/scroll";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center p-10 text-center font-sans">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="relative bg-paper font-sans text-ink antialiased selection:bg-accent selection:text-paper">
      <div className="grain" aria-hidden="true" />
      <a
        href="#home"
        data-testid="skip-to-content-link"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-lg focus:bg-ink focus:px-4 focus:py-2 focus:text-paper"
      >
        Skip to content
      </a>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Sectors />
        <Resources />
        <Download />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <MotionConfig reducedMotion="user">
        <Site />
      </MotionConfig>
    </ErrorBoundary>
  );
}
